import { Mapper } from "../../../../base/utils/mapper";
import { LensiometryResponseModel } from "../../../../domain/models/consult/lensiometry-response.model";
import { LensiometryResponseEntity } from "../entities/lensiometry-response.entity";


export class LensiometryImplementationRepositoryMapper extends Mapper<LensiometryResponseEntity, LensiometryResponseModel> {
    mapFrom(param: LensiometryResponseEntity): LensiometryResponseModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: LensiometryResponseModel): LensiometryResponseEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}